<template>
    <div id="app">
        <div v-if="nakdanType.Simple || nakdanStyle.Desktop" class="he full-height d-flex flex-column" dir="rtl">
            <headers :global-modes-obj="globalModesObj" v-if="nakdanStyle.Desktop" v-on:show-keyboard-shortcuts="showKeyboardShortcuts"></headers>
            <router-view class="main-content" 
                         :global-modes-obj="globalModesObj"
                         v-bind:class="{'main-content-desktop': nakdanStyle.Desktop}"
                         v-on:show-keyboard-shortcuts="showKeyboardShortcuts"/>
            <login v-if="renderLogin"></login>
            <div id="change-password-msg" class="notify-msg variable-height-msg" style="display:none;">
                <p class="f white">text will be filled in by code</p>
            </div>
            <keyboard-shortcuts ref="keyboard-shortcuts"/>
        </div>
        <div v-else class="d-md-none d-block text-white h-100 text-center bg-primary">
            <div class="logo-holder"><img class="logo" src="@/assets/logo.png"></div>
            <h2 class="f-narkis py-5">
                הַנַּקְדָן <span v-if="nakdanType.Pro">הַמִּקְצוֹעִי </span>אֵינוֹ זָמִין בַּנַּיָּד.
                <span v-if="nakdanType.Pro"><br>
                תּוּכְלוּ לַעֲבֹר לַנַּקְדָן הָרָגִיל.</span>
            </h2>
            <a v-if="nakdanType.Pro" href="https://nakdan.dicta.org.il/" class="btn btn-light bg-white text-primary">לנקדן הרגיל</a>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Login from './components/login.vue'
    import headers from './components/headers'
    import KeyboardShortcuts from './components/KeyboardShortcuts'
    import {NakdanType, SimpleVsProConfig} from './simpleVsProConfig.js'
    import {NakdanStyle} from '@/mobileVsDesktopConfig.js'

    export default {
        components: {
            Login,
            headers,
            KeyboardShortcuts
        },
        name: 'App',
        data () {
            return {
                globalModesObj: {
                    allowLeaving: false
                }
            }
        },
        methods: {
            showKeyboardShortcuts() {
                this.$refs['keyboard-shortcuts'].$children[0].show() // the $ref is the COMPONENT, $children[0] is the modal
            },
            multiModal() {
                $(document).on('show.bs.modal', '.modal', function () {
                    var zIndex = 1040 + (10 * $('.modal:visible').length);
                    $(this).css('z-index', zIndex);
                    setTimeout(function () {
                        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                    }, 0);
                });
            },
        },
        computed: {
            nakdanType () {
                return NakdanType
            },
            nakdanStyle () {
                return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
            },
            renderLogin () {
                return SimpleVsProConfig.IMPLEMENT_USER_ACCOUNTS
            }
        },
        mounted() {
            this.multiModal();
        }
    }
</script>

<style lang="scss">
    .bg-background {
      background: #f6f6f6;
    }
    .he .custom-control {
        padding-left: 0;
        padding-right: 1.5rem;
    }

    .he .custom-control-label:after, .he .custom-control-label:before {
        left: initial;
        right: -1.5rem;
    }

    @font-face {
        font-family: 'mfw_korentanakh_bold';
        src: url('assets/fonts/KorenTanakh-bold_MFW_FixedQQ.woff') format('woff');
        font-style: normal;
        font-weight: normal;
    }

    @font-face {
        font-family: 'mft_narkisclassic';
        src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
        font-style: normal;
        font-weight: normal;
    }

    @font-face {
        font-family: mft_narkisclassic;
        src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
        font-style: normal;
        font-weight: bold;
    }

    .f-narkis {
        font-family: Roboto, mft_narkisclassic, sans-serif;
        line-height: 1.5;
    }

    .f-koren {
        font-family: mfw_korentanakh_bold;
    }

    .home {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    #app {
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #F6F6F6;
        z-index:1;
    }

    .mobile-landscape {
        display: none;
    }
    footer.d-block.d-none{display: none!important;}

    /* Smartphones (landscape) ----------- */
    @media only screen and (min-device-width: 320px) and (max-device-width: 568px)
    and (-webkit-device-pixel-ratio: 2) and (device-aspect-ratio: 40/71) and (orientation:landscape)
    { 
        .mobile-landscape {
            display: block!important;
            visibility: visible!important;
        }
        #app {
            display: none;
        }
    }    
    @media (orientation: landscape) and (max-width: 768) {
        .mobile-landscape {
            display: block;
            visibility: visible!important;
        }
        #app {
            display: none;
        }
    }
    .notify-msg {
        position: fixed;
        right: 24px;
        bottom: 48px;
        width: 238px;
        height: 50px;
        padding: 15px 8px;
        text-align: center;
        border-radius: 3px;
        box-sizing: border-box;
        background-color: #494949;
        @media (max-width: 767px) {
          right: auto;
          left:10px;
          height: auto;
          padding: 12px 8px;
      }
    }

    .variable-height-msg {
        height: unset !important;
    }

    .notify-msg p{
        margin: 0;
        color: white;
    }

    .main-content {
      flex: auto;
      @media (max-width: 676px) {
          overflow: auto
      };
      height: 100%;
    }

    .main-content-desktop {
      min-height: 100px;
      padding: 30px 15px;
      height: calc(100% - 40px) !important;
    }

    .download-popup .dropdown-toggle,  .download-popup .dropdown-menu {
        width: 200px;
        right: 0;
    }

    .nikud-pane-container .dropdown, .download-popup .dropdown {
        margin-top: 0;
    }
   .login-dropdown-menu{
        min-width: 15rem;
    }
    .pane-title-bar {
        padding: 2px 8px;
        text-align: right;
        background-color: #E3E3E3;
        color: #000;
        font-family: Arimo;
        cursor: pointer;
        border-radius: 3px;
        height: 28px;
    }

    .pane-title-bar.active, .pane-title-bar:hover {
        background-color: #d6ecff;
        color: #007EE5;
    }

    .settings-button {
        float: left;
    }

    a.clickable-link {
        margin-right: 14px;
        color: black;
        text-decoration: underline;
    }

    a.clickable-link:hover {
        color: black;
        text-decoration: underline;
    }

    a.clickable-link:focus {
        color: black;
        text-decoration: underline;
    }

    .nikud-options-account-needed-popup, .manual-nikud-account-needed-popup, .copy-options-popup {
        position: absolute;
        z-index: 2;
        border-color: transparent;
        font-size: 14px;
        border-radius: 2px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        background-color: #ffffff;
    }
    .nikud-options-account-needed-popup, .manual-nikud-account-needed-popup {
        padding: 8px;
        margin-right: 1px;
        margin-left: 4px;
        bottom: 80px; /* the one for "options" will be changed dynamically */
    }

    .nikud-keyboard-popup, .download-popup, .prompt-popup {
        position: absolute;
        left: 450px;
        top: 20%;
        z-index: 20;
        background-color: white;
        padding: 0 0 8px;
        border-style: solid;
        border-color: gray;
    }

    .nikud-keyboard-popup {
        height: 300px;
        width: 400px;
    }

    .download-popup {
        height: 250px;
        width: 400px;
    }

    .prompt-popup {
        height: 160px;
        width: 250px;
        padding: 5px;
    }

    .download-popup {
        left: 250px;
    }

    .apply-to-all-popup p, .nikud-keyboard-popup p, .download-popup p {
        padding-right: 8px;
        margin-bottom: 6px;
    }

    .apply-to-all-popup button, .nikud-keyboard-popup button, .download-popup button {
        margin: 0 0 8px 8px;
    }

    .bottom-of-popup {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    #change-password-popup, .change-password-footer,
    #failed-validation-modal, .failed-validation-footer, 
    #go-home-modal, .go-home-footer, 
    #go-to-pro-modal, .go-to-pro-footer, 
    #back-to-text-modal, .back-to-text-footer, 
    #switch-genre-modal .switch-genre-footer, 
    #text-too-long-modal, .text-too-long-footer {
        border-top: 1px solid #e3e3e3;
        justify-content: center;
    }

    #back-to-text-modal .back-to-text-footer .btn, 
    #go-to-pro-modal .go-to-pro-footer .btn, 
    #switch-genre-modal .switch-genre-footer .btn,
    #text-too-long-modal .text-too-long-footer .btn {
        width: 100%;
    }

    .scroll-modal {
        height: 70vh;
        overflow: auto;
    }

    .fa-star {
        color: #68B8F8;
    }

    .pointer {
        cursor: pointer;
    }

    .popover {
        text-align: right;
        -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
        left: -5px !important;
        border: 0;
        max-width: 270px;
        margin-bottom: 4px;
    }
    .popover .arrow {
        display: none;
    }
    .popover-body {
        padding: 1rem;
    }

    .dictionary-button {
        border-radius: 15px;
        padding: 1px;
        width: 16px;
        height: 16px;
        text-align: center;
        margin-right: 2px;
        color: #989a97 !important;
        font-size: 10px;
        display: inline-block;
        vertical-align: middle;
        line-height: 1.5;
    }

    .dictionary-button:hover {
        background: #F6F6F6;
    }
    .bordered-footer {
      padding: 12px;
      border-top: solid 1px rgba(0, 0, 0, 0.1);
    }
    .full-height {
        height: 100%;
    }
    .accordion-header {
        background-color: white;
        border-bottom: 0;
        padding: 0;
        height: 28px;
        border-radius: 4px;
    }

    .accordion-toggle-btn {
        background: white;
        border: 0;
        text-align: right;
        height: 100%;
        color: #000;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        border-radius: 4px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    }

    .accordion-toggle-btn:not(:disabled):not(.disabled):hover,
    .accordion-toggle-btn:not(:disabled):not(.disabled):active,
    .accordion-toggle-btn:not(:disabled):not(.disabled).active,
    .accordion-toggle-btn:not(:disabled):not(.disabled)[aria-expanded="true"] {
        background-color: #f6f6f6;
        outline: none;
        color: #007EE5;
        border-radius: 4px 4px 0 0;
    }
    .accordion-toggle-btn:not(:disabled):not(.disabled):active,
    .accordion-toggle-btn:not(:disabled):not(.disabled).active,
    .accordion-toggle-btn:not(:disabled):not(.disabled)[aria-expanded="true"] {
        box-shadow: none !important;
    }

    .tooltip-inner {
        white-space: nowrap;
    }
    @media (max-width: 991px) {
        .container {
            max-width: 100%;
        }
    }
    .modal-backdrop:not(.show):not(.fade) {
        opacity: 0.2;
    }
    @media (max-width: 991px) {
        body,#app{
            min-height:100%;
            position: fixed;
            width: 100%;
            left:0;
        }
        body.ios-main, .ios-main #app,
        body.ios-toolbar-gone, .ios-toolbar-gone #app {
          position:static;
        }        
    }
</style>
<style scoped>
  .logo-holder {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    width: 80px;
    height: 80px;
    background-color: white;
    margin: 100px 0 10px;
  }
  .logo {
    height: 50px;
  }
</style>
